import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.ts';
import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { space } from '@synoptic/ui-kit/tokens.ts';
import { typography } from '@synoptic/ui-kit/typography.ts';
import { style } from '@vanilla-extract/css';

export const websiteLink = style({
  display: 'flex',
  alignItems: 'center',
  gap: space.s6,
  color: themeVars.tag.foreground,
  backgroundColor: themeVars.tag.default.background.idle,
  borderRadius: 60,
  padding: `${space.s2}px ${space.s8}px`,
  width: 'fit-content',

  ...responsiveStyle({
    mobile: {
      ...typography['labelSm'],
    },
    desktop: {
      ...typography['bodySm'],
    },
  }),
});
